'use strict';

var zoomModel = require('./pyPdpZoom');

var $activeThumb;
var initialIndex;
var lastWindowWidth = $(window).width();

var carouselSettings = {
    desktopSettings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        speed: 0
    },
    mobileSettings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false
    },
    thumbnailCarousel: {
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: false,
        arrows: true,
        infinite: false
    }
};

let topInitialized = false;
let thumbInitialized = false;

/**
 * Handles active slide on bottom thumbnail slider
 * @function HandleActiveSide
 * @param {jQuery} $thumbSlider - Bottom thumbnail slider
 * @param {number} index - Index of the slide to activate
 */
function HandleActiveSide($thumbSlider, index) {
    if (topInitialized && thumbInitialized) {
        $thumbSlider.find('.slick-slide').removeClass('slide-active').eq(index).addClass('slide-active');
    }
}

$(document).on('hidden.bs.modal', function () {
    var anyModalOpen = $('.modal.show').length > 0;
    $('body').toggleClass('modal-open', anyModalOpen);
});

/**
 * Initializes slick carousel for top and bottom sliders
 * @function initSlickCarousel
 */
function initSlickCarousel() {
    const $primaryImages = $('.primary-images');
    const $slickSlider = $primaryImages.find('.herobanner-top');
    const $thumbSlider = $primaryImages.find('.herobanner-bottom');
    const isDesktop = $(window).width() >= 1024;

    if (!$slickSlider.length) return; // Guard clause if no slider exists

    $activeThumb = $thumbSlider.find('.slide-active');
    initialIndex = $activeThumb.length ? $activeThumb.data('slick-index') : 0;

    // Destroy if initialized
    [$slickSlider, $thumbSlider].forEach($slider => {
        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
        }
    });

    // Clone the settings to avoid modifying original object
    var baseTopSettings = isDesktop ? carouselSettings.desktopSettings : carouselSettings.mobileSettings;
    const topSettings = Object.assign({}, baseTopSettings, {
        initialSlide: initialIndex
    });

    // If there's a previously active slide, set speed to 0
    if ($activeThumb.length) {
        topSettings.speed = 0;
    }

    const slickConfigs = {
        top: topSettings,
        bottom: carouselSettings.thumbnailCarousel
    };

    // Init slicks
    $slickSlider.slick(slickConfigs.top);
    if (isDesktop && $thumbSlider.length) {
        $thumbSlider.slick(slickConfigs.bottom);
    }

    // Unbind previous events before binding new ones
    $slickSlider.off('init beforeChange click');
    $thumbSlider.off('init mouseenter click');

    // Init events
    $slickSlider.on('init', function () {
        topInitialized = true;
        HandleActiveSide($thumbSlider, initialIndex);
    });

    $thumbSlider.on('init', function () {
        thumbInitialized = true;
        HandleActiveSide($thumbSlider, initialIndex);
    });

    const interactionEvent = isDesktop ? 'mouseenter' : 'click';

    if (isDesktop) {
        // Desktop thumbnail click/hover sync
        $thumbSlider.on(interactionEvent, '.slick-slide', function (event) {
            event.preventDefault();
            const slideIndex = $(this).data('slick-index');
            $slickSlider.slick('slickGoTo', slideIndex);
            $(this).addClass('slide-active').siblings().removeClass('slide-active');
        });

        $slickSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $thumbSlider.find('.slick-slide').removeClass('slide-active').eq(nextSlide).addClass('slide-active');
        });
    } else {
        // Mobile indicators click
        $primaryImages.off('click', '.herobanner-bottom .imgid-pdp').on('click', '.herobanner-bottom .imgid-pdp', function () {
            var slideIndex = $(this).data('indicator');
            $slickSlider.slick('slickGoTo', parseInt(slideIndex, 10));
        });

        $slickSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var mobileIndicators = $primaryImages.find('.herobanner-bottom .imgid-pdp').toArray();
            $(mobileIndicators).removeClass('active');
            $(mobileIndicators[nextSlide]).addClass('active');
        });

        // Mobile click to open zoom modal
        $slickSlider.on('click', '.slick-slide', function (e) {
            e.preventDefault();
            var index = $(this).data('slick-index');
            var $modal = $('#productZoomPopup');
            var $carousel = $('.image-slider');

            $modal.modal('show');
            $carousel.carousel(index);

            if (index === 0) {
                $carousel.find('.carousel-indicators li').removeClass('active').first().addClass('active');
            }
        });
    }

    // Modal indicators layout adjustment (attach once globally)
    $primaryImages.off('shown.bs.modal', '#productZoomPopup').on('shown.bs.modal', '#productZoomPopup', function () {
        var totalWidth = 0;
        $('#carouselIndicators li').each(function () {
            totalWidth += $(this).outerWidth(true);
        });
        var containerWidth = $('.product-zoom-body .modal-body').width();
        var singleThumbWidth = $('#carouselIndicators li').first().outerWidth(true);
        var visibleArea = containerWidth - singleThumbWidth;

        if (totalWidth > visibleArea) {
            $('#carouselIndicators').addClass('justify-content-start').removeClass('justify-content-center');
        } else {
            $('#carouselIndicators').addClass('justify-content-center').removeClass('justify-content-start');
        }
    });

    // Remove preload class
    $slickSlider.removeClass('init-carousel');
    $thumbSlider.removeClass('init-carousel');

    zoomModel.initImageZoom();
}

// Initial load
$(window).on('load', function () {
    initSlickCarousel();
});

$(window).on('resize', function () {
    const currentWidth = $(window).width();
    if (currentWidth !== lastWindowWidth) {
        lastWindowWidth = currentWidth;
        initSlickCarousel();
    }
    const $modal = $('.primary-images').find('#productZoomPopup');
    if (currentWidth >= 1024 && $modal.hasClass('show')) {
        $modal.modal('hide');
    }
});

module.exports = {
    initSlickCarousel: initSlickCarousel
};
